import {createSelector} from 'reselect';
import {getEventGenre} from '@stubhub/tracking-utils';
import {isPrimaryEvent, isDefined} from '@stubhub/general-utils';
import {daysBetweenDates} from '@stubhub/date-utils';
import CONNECTIONS_MAP from '../../common/enums/connections';

const eventSelector = (state) => state && state.eventData || {};
const eventIdSelector = createSelector(eventSelector, (event) => event.eventId || null);
const eventDataSelector = createSelector(eventSelector, (event) => event.eventData || {});
const venueSelector = createSelector(eventDataSelector, (eventData) => eventData.venue || {});
const eventNameSelector = createSelector(eventDataSelector, (event) => event.name || null);
const eventDateUTCSelector = createSelector(eventDataSelector, (event) => event.eventDateUTC || '');
const daysToEventSelector = createSelector(eventDateUTCSelector, (date = {}) => (date ? +daysBetweenDates(Date.now(), date)?.toFixed(2) : 0));
const ancestorsSelector = createSelector(eventDataSelector, (eventInfo = {}) => eventInfo.ancestors || {});
const eventCountrySelector = createSelector(venueSelector, (venue = {}) => venue.country || null);
const categoriesSelector = createSelector(ancestorsSelector, (ancestors = {}) => ancestors.categories || []);
const genreSelector = createSelector(categoriesSelector, (categories = []) => (categories && categories.length > 0 ? getEventGenre(categories[0].id) : getEventGenre(-1)));
const inventoryMarketSelector = createSelector(eventDataSelector, (event = {}) => (isDefined(event.externalSourceId) ? (isPrimaryEvent(event.externalSourceId) ? 'primary' : 'secondary') : null));
const isEventDataLoadedSelector = createSelector(eventSelector, (eventData) => eventData.loaded || false);
const seatDetailsSelector = (state) => state?.['seat-details'] || {};
const numFeaturesSelector = createSelector(seatDetailsSelector, (seatDetails) => seatDetails?.features?.length || 0);
const numRestrictionsSelector = createSelector(seatDetailsSelector, (seatDetails) => seatDetails?.restrictions?.length || 0);
const connectionsSelector = createSelector(seatDetailsSelector, (seatDetails) => seatDetails?.connections?.map((connection) => CONNECTIONS_MAP[connection.id])?.join('/') || 'no');
const selectEventData = createSelector(eventSelector, (eventData) => eventData);
const imagesSelector = createSelector(eventDataSelector, ({images}) => images || []);
const imageURLSelector = createSelector(imagesSelector, (images) => ((images[0] && images[0].url) ? images[0].url : null));
const onSaleDateSelector = createSelector(eventDataSelector, ({dynamicAttributes} = {}) => {
  const onSaleDate = dynamicAttributes && dynamicAttributes.find((attr) => attr.name === 'event_schedule_date');
  return (onSaleDate && onSaleDate.value) ? onSaleDate.value : null;
});

export {
  genreSelector,
  ancestorsSelector,
  inventoryMarketSelector,
  eventIdSelector,
  eventNameSelector,
  daysToEventSelector,
  eventCountrySelector,
  isEventDataLoadedSelector,
  numFeaturesSelector, 
  connectionsSelector,
  numRestrictionsSelector,
  selectEventData,
  onSaleDateSelector,
  imageURLSelector,
  eventDateUTCSelector
};
